import { foundationFileUploadStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroFileUploadStyles = css `
  ${foundationFileUploadStyles}
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: rgb(31 33 38);
  }

  ::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0 0 0 / 30%);
    background-color: var(--neutral-color);
    border: 3px solid rgb(31 33 38);
  }
`;
